import ModalXs from "../../components/Modal/ModalXs";
import AccountSecurity from "./AccountSecurity";

const AccountSecurityModal = () => {
  return (
    <ModalXs title={"31"}>
      <AccountSecurity />
    </ModalXs>
  );
};

export default AccountSecurityModal;
